export function convertToChineseMoney(money) {
    // 验证输入
    if (typeof money !== 'number' && typeof money !== 'string') {
        throw new Error('输入必须是数字或字符串格式的金额');
    }
    
    // 转换为字符串并处理
    let numStr = String(money).trim();
    if (!/^-?\d+(\.\d{1,2})?$/.test(numStr)) {
        throw new Error('金额格式错误，只能包含数字、最多两位小数，且不能是负数');
    }
    
    // 处理负数（实际财务场景中通常不允许负数，这里直接抛出错误）
    if (numStr.startsWith('-')) {
        throw new Error('金额不能为负数');
    }
    
    // 分离整数和小数部分
    let [integerPart, decimalPart] = numStr.split('.');
    decimalPart = decimalPart || '';
    
    // 数字对应的中文
    const digits = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
    // 整数部分单位
    const intUnits = ['', '拾', '佰', '仟', '万', '拾', '佰', '仟', '亿', '拾', '佰', '仟'];
    // 小数部分单位
    const decimalUnits = ['角', '分'];
    
    // 处理整数部分
    let integerChinese = '';
    if (integerPart === '0' && decimalPart === '') {
        integerChinese = '零';
    } else {
        for (let i = 0; i < integerPart.length; i++) {
            const digit = parseInt(integerPart[i], 10);
            const position = integerPart.length - 1 - i; // 单位位置
            
            if (digit !== 0) {
                integerChinese += digits[digit] + intUnits[position];
            } else {
                // 处理零的情况：连续零只显示一个，且亿、万单位前的零不显示
                if (
                    integerChinese[integerChinese.length - 1] !== '零' && 
                    position !== 8 &&  // 亿位
                    position !== 4    // 万位
                ) {
                    integerChinese += '零';
                }
            }
            
            // 处理亿和万单位（即使后面是零也保留单位）
            if ((position === 8 || position === 4) && integerChinese[integerChinese.length - 1] !== intUnits[position]) {
                integerChinese += intUnits[position];
            }
        }
    }
    
    // 处理小数部分
    let decimalChinese = '';
    if (decimalPart) {
        for (let i = 0; i < decimalPart.length; i++) {
            const digit = parseInt(decimalPart[i], 10);
            if (digit !== 0) {
                decimalChinese += digits[digit] + decimalUnits[i];
            } else {
                // 角为零分时显示零分，分位为零则不显示
                if (i === 0 && decimalPart.length > 1 && parseInt(decimalPart[1], 10) !== 0) {
                    decimalChinese += '零';
                }
            }
        }
    }
    
    // 组合结果
    let result = '';
    if (integerChinese) {
        result += integerChinese + '元';
    }
    if (decimalChinese) {
        result += decimalChinese;
    } else {
        // 没有小数部分时加"整"
        result += '整';
    }
    
    return result;
}


//////////////////
// WEBPACK FOOTER
// ./tool/amount.js
// module id = null
// module chunks = 